import { render, staticRenderFns } from "./AnnotationDetailsPanel.vue?vue&type=template&id=7b5b4b6a&scoped=true"
import script from "./AnnotationDetailsPanel.vue?vue&type=script&lang=js"
export * from "./AnnotationDetailsPanel.vue?vue&type=script&lang=js"
import style0 from "./AnnotationDetailsPanel.vue?vue&type=style&index=0&id=7b5b4b6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5b4b6a",
  null
  
)

export default component.exports